
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface CancellationSectionProps {
  onCancel: () => void;
  processingPayment: boolean;
  cancelling: boolean;
}

export const CancellationSection = ({
  onCancel,
  processingPayment,
  cancelling,
}: CancellationSectionProps) => {
  return (
    <div className="mt-8 pt-6 border-t border-gray-200">
      <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
        <div>
          <h4 className="text-base font-semibold flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-4 w-4" />
            Cancel Subscription
          </h4>
          <p className="text-sm text-muted-foreground mt-1">
            Your subscription will remain active unless you choose to change or cancel it.
          </p>
        </div>
        <Button
          variant="destructive"
          onClick={onCancel}
          disabled={processingPayment || cancelling}
          className="w-full sm:w-auto"
        >
          {cancelling ? "Cancelling..." : "Cancel Subscription"}
        </Button>
      </div>
    </div>
  );
};
